import { BrokerType } from 'enums/shared/brokerType';
import { useTranslation } from 'react-i18next';

const useBrokerName = (): ((brokerType: BrokerType) => string) => {
  const { t } = useTranslation();

  const names: Record<BrokerType, string> = {
    [BrokerType.Tradernet]: t('tradernetBroker'),
    [BrokerType.Freedom]: t('freedomBroker'),
    [BrokerType.Tinkoff]: t('tinkoffBroker'),
    [BrokerType.Finam]: t('finamBroker'),
    [BrokerType.Binance]: t('binanceTitle'),
    [BrokerType.PE]: t('peAccount'),
    [BrokerType.Crypto]: t('cryptoAccount'),
    [BrokerType.Arbitr]: t('arbitrAccount'),
    [BrokerType.CryptoDeposit]: 'CryptoDeposit',
    [BrokerType.NVB]: 'NVB',
    [BrokerType.PrimeIPO]: 'Prime IPO',
    [BrokerType.IPO]: 'IPO',
  };

  return (brokerType: BrokerType) => names[brokerType];
};

export default useBrokerName;
